import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Moon, Sun, Search, Globe, CircleAlert } from 'lucide-react';
import { useTheme } from '@/theme/useTheme';
import i18n, { setLanguage } from '@/i18n';
import { Button } from '@/components/ui/Button';
import { UserMenu } from './UserMenu';
import { NotificationsMenu } from './NotificationsMenu';
import { usePalette } from '@/stores/ui';
import { ReportProblemModal } from '@/features/support/ReportProblemModal';

/** Top bar: global search (<60s document rule), theme + language toggles, alerts. */
export function Topbar() {
  const { t } = useTranslation();
  const { mode, toggle } = useTheme();
  const [reporting, setReporting] = useState(false);

  const switchLang = () => {
    const next = i18n.language === 'es' ? 'en' : 'es';
    void setLanguage(next);
  };

  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 px-4 py-3 lg:px-6">
      <button
        type="button"
        onClick={() => usePalette.getState().setOpen(true)}
        className="glass focus-ring flex min-w-0 flex-1 items-center gap-3 rounded-2xl px-4 py-2.5 text-left"
      >
        <Search className="h-4 w-4 flex-none text-muted-foreground" />
        <span className="min-w-0 flex-1 truncate text-sm text-muted-foreground">{t('actions.search')}</span>
        <kbd className="hidden rounded-md border border-border px-1.5 py-0.5 text-[10px] text-muted-foreground sm:block">
          ⌘K
        </kbd>
      </button>

      {/* Reportar un problema (VLT-328): a dos clics desde cualquier pantalla */}
      <Button variant="glass" size="sm" onClick={() => setReporting(true)} aria-label={t('support.reportCta')}>
        <CircleAlert className="h-4 w-4" />
        <span className="hidden md:inline">{t('support.reportCta')}</span>
      </Button>

      <Button variant="glass" size="sm" aria-label="Language" onClick={switchLang}>
        <Globe className="h-4 w-4" />
        <span className="uppercase">{i18n.language}</span>
      </Button>

      {/* VLT-361: centro de notificaciones REAL — avisos derivados de datos
          vivos, contador honesto (solo si hay algo). */}
      <NotificationsMenu />

      <Button
        variant="glass"
        size="sm"
        aria-label="Toggle theme"
        onClick={toggle}
        className="hidden sm:inline-flex"
      >
        {mode === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>

      <UserMenu />
      <ReportProblemModal open={reporting} onClose={() => setReporting(false)} />
    </header>
  );
}
